import { Route, Routes, useLocation } from 'react-router-dom';
// import AppLayout from 'src/layout/AppLayout';
// import Home from 'src/pages/home/Home';
// import MintList from 'src/pages/mint/MintList';
// import MintProject from 'src/pages/mint/MintProject';
// import OpenBox from 'src/pages/openbox/OpenBox';
// import ProfileKey from 'src/pages/profile/ProfileKey';
// import CollectionDetail from 'src/pages/openbox/CollectionDetail';
// import RaffleList from 'src/pages/raffle/RaffleList';
// import RaffleDetail from 'src/pages/raffle/detail/RaffleDetail';
// import RaffleCollectionDetail from 'src/pages/raffle/openbox/RaffleCollectionDetail';
// import QiibeeCollectionDetail from 'src/pages/qiibee/openbox/QiibeeCollectionDetail';
// import AvaxOpenbox from 'src/pages/avax/openbox/AvaxOpenbox';
// import ArenaCollectionDetail from 'src/pages/arena/openbox/ArenaCollectionDetail';
// import Leaderboard from 'src/pages/multiverx/Leaderboard';
// import LeaderboardDetail from 'src/pages/LeaderboardDetail.tsx';
import { useLayoutEffect } from 'react';
// import DiscordCallback from 'src/pages/discord/DiscordCallback';
// import TwitterCallback from 'src/pages/twitter/TwitterCallback';
// import ArenaMintProject from 'src/pages/mint/ArenaMintProject';
// import YoutubeCallback from 'src/pages/youtube/YoutubeCallback';
// import VideoPage from 'src/pages/youtube/video/VideoPage';
// import VideoPage2 from '../pages/youtube/video/VideoPage2.tsx';
// import VideoPage3 from 'src/pages/youtube/video/VideoPage3.tsx';
// import VideoPage4 from 'src/pages/youtube/video/VideoPage4.tsx';
// import VideoPage5 from 'src/pages/youtube/video/VideoPage5.tsx';
// import Referral from 'src/pages/Referral/Referral.tsx';
// import AdminPanel from 'src/pages/admin/AdminPanel.tsx';
// import VideoPage6 from 'src/pages/youtube/video/VideoPage6.tsx';
// import VideoPage7 from 'src/pages/youtube/video/VideoPage7.tsx';
// import GeneralVideoPage from 'src/pages/youtube/video/GeneralVideoPage.tsx';
// import EnclaveOpenbox from 'src/pages/enclave/openbox/EnclaveOpenbox.tsx';
// import EnclaveMint from 'src/pages/enclave/mint/EnclaveMint.tsx';
// import AvaxMint from 'src/pages/avax/mint/AvaxMint.tsx';
// import MultiversMint from 'src/pages/multiverx/mint/MultiversMint.tsx';
// import MultiversxOpenbox from 'src/pages/multiverx/openbox/MultiversxOpenbox.tsx';
// import ChromeUser from 'src/pages/admin/ChromeUser.tsx';
// import Home_v2 from 'src/pages/Home_v2.tsx';
import ComingSoon_v2 from 'src/pages/ComingSoon_v2.tsx';

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    const mainElement = document.getElementById('app-layout-main');

    if (mainElement) {
      mainElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [location.pathname]);

  return children;
};

export default function AppRouter() {
  return (
    <Wrapper>
      <Routes>
        <Route path="*" element={<ComingSoon_v2 />} />

        {/* <Route path="/" element={<ComingSoon />} /> */}
        {/* <Route path="/home" element={<Home_v2 />} />
        <Route path="/coming-soon" element={<ComingSoon_v2 />} /> */}

        {/* <Route path="/" element={<AppLayout />}> */}
        {/* <Route index element={<Home />} />

          <Route path="mint">
            <Route index element={<MintList />} />
            <Route path=":id" element={<MintProject />} />
          </Route>

          <Route path="arena">
            <Route path=":id/:stageId" element={<ArenaMintProject />} />
          </Route>

          <Route path="openbox">
            <Route index element={<OpenBox />} />
            <Route path=":collectionName" element={<CollectionDetail />} />
          </Route>

          <Route path="qiibee">
            <Route path="openbox/:collectionName" element={<QiibeeCollectionDetail />} />
          </Route>

          <Route path="avax">
            <Route path=":id/:stageId" element={<AvaxMint />} />
            <Route path="openbox/:collectionName" element={<AvaxOpenbox />} />
          </Route>

          <Route path="raffle">
            <Route index element={<RaffleList />} />
            <Route path="list/:collectionName" element={<RaffleDetail />} />
            <Route path="openbox/:collectionName" element={<RaffleCollectionDetail />} />
          </Route>

          <Route path="multiversx">
            <Route path=":id/:stageId" element={<MultiversMint />} />
            <Route path="openbox/:collectionName" element={<MultiversxOpenbox />} />
          </Route>

          <Route path="enclave">
            <Route path=":id/:stageId" element={<EnclaveMint />} />
            <Route path="openbox/:collectionName" element={<EnclaveOpenbox />} />
          </Route>

          <Route path="arena">
            <Route path="openbox/:collectionName" element={<ArenaCollectionDetail />} />
          </Route>

          <Route path="profile">
            <Route path="keys" element={<ProfileKey />} />
          </Route> */}

        {/* <Route path="leaderboards">
            <Route index element={<Leaderboard />} />
            <Route path=":collectionSlug" element={<LeaderboardDetail />} /> */}
        {/* <Route path=":collectionSlug" element={<EnclaveDetail />} /> */}
        {/* </Route> */}

        {/* <Route path="auth/discord/callback" element={<DiscordCallback />} />
          <Route path="auth/twitter/callback" element={<TwitterCallback />} />
          <Route path="auth/youtube/callback" element={<YoutubeCallback />} />
          <Route path="/video/what-is-egld" element={<VideoPage />} />
          <Route path="/video/the-only-crypto-wallet-you-will-ever-need" element={<VideoPage2 />} />
          <Route path="/video/what-is-sharding" element={<VideoPage3 />} />
          <Route path="/video/how-ai-is-changing-the-world" element={<VideoPage4 />} />
          <Route path="/video/why-im-betting-big-on-multiversx" element={<VideoPage5 />} />
          <Route path="/video/ai-agents-multiversx-eliza-setup" element={<VideoPage6 />} />
          <Route path="/video/ai16z-mvx-plugin-client-systems" element={<VideoPage7 />} />

          <Route path="/video/:slug" element={<GeneralVideoPage />} />

          <Route path="/referral" element={<Referral />} />

          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/krome" element={<ChromeUser />} /> */}
        {/* </Route> */}
      </Routes>
    </Wrapper>
  );
}
